module.exports = __webpack_public_path__ + "assets/images/park-02.a2ca6104e3c2d9ecb0096a6196862c8a.svg";